export const SET_PAGE_CACHE = 'SET_PAGE_CACHE';
export const SET_SOLR_CACHE = 'SET_SOLR_CACHE';
